import React, { useContext, useMemo, useState } from 'react';
//import { FaCircle } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import DetailsTable from '../../../../../components/CustomTable/DetailsTable';
import CustomTableOffcanvas from '../../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { UserContext } from '../../../../../modules/contexts/Auth/UserProvider';
import { useDenominacoesGenericasCache } from '../../../../../services/cache/useDenominacoesGenericasCache';
import { useAcondicionamento } from '../../../../../services/enum/useAcondicionamento';
import { useGrupoFinanciamento } from '../../../../../services/enum/useGrupoFinanciamento';
import { useTipoProduto } from '../../../../../services/enum/useTipoProduto';
import { useUmidadeProduto } from '../../../../../services/enum/useUmidadeProduto';
import SubAbas from '../../subabas';
import {
  headersProdutos as headersTable,
  ProdutosTableRow,
  valoresExibidosProdutos as valoresExibidos,
} from '../auxiliarProdutosDaf';
import { buildOffCanvasData } from './offcanvasProdutosDaf';
import { buildProdutosTableData } from './tableProdutosDaf';
import { useProdutosDafCache } from '../../../../../services/cache/useProdutosDafCache';

const ProdutosDafListagem: React.FC = () => {
  const { cudProdutoDaf } = useContext(UserContext);
  const grupoFinanciamento = useGrupoFinanciamento();

  const navigate = useNavigate();
  const tipoProduto = useTipoProduto();
  const acondicionamentoProduto = useAcondicionamento();
  const umidadeProduto = useUmidadeProduto();
  const theme = useTheme();
  const location = useLocation();
  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);

  // Buscar dados com cache
  const { data } = useProdutosDafCache();
  useDenominacoesGenericasCache();

  const getTipoProdutoInfo = (item: any) => {
    const tipo = item?.denominacaoGenerica?.tipoProduto;
    if (typeof tipo === 'number' && tipoProduto?.[tipo]) {
      return tipoProduto[tipo].label;
    }
    return 'Não informado';
  };

  const tableData = buildProdutosTableData(data, getTipoProdutoInfo);

  //Dados do Offcanvas
  const offCanvasData = buildOffCanvasData(data, theme, {
    getTipoProdutoInfo,
    umidadeProduto,
    acondicionamentoProduto,
    grupoFinanciamento,
  });

  const handleTableRowClick = (row: ProdutosTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  const handleOpenDetails = (row: ProdutosTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const offcanvasOpenRoute = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!selectedDetailsRowId) return undefined;
    const fichaPath = `/${selectedDetailsRowId}/dadosgerais`;
    return `${window.location.origin}/#${location.pathname}${fichaPath}`;
  }, [selectedDetailsRowId, location.pathname]);

  const handleClickInserir = () => {
    navigate('dadosgerais');
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersTable}
          data={tableData}
          displayValues={valoresExibidos}
          offcanvasTitle="Produto DAF - Detalhes"
          widthOffcanvas="60%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          // emptyMessage="Nenhum registro encontrado."
          showPagination={true}
          showOpenButton={true}
          filterable={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidos}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // onClickDownload={() =>
          //   exportProdutosToExcel({
          //     data,
          //     listaDenominacoesGenericas,
          //     tipoProdutoOptions: tipoProduto,
          //     userID,
          //     valoresExibidos,
          //     fieldObjectProdutosDaf,
          //     entity,
          //   })
          // }
          inserir
          inserirDisabled={!cudProdutoDaf}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ProdutosDafListagem;
